import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Lenis from 'lenis';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { WhatsAppFloat } from '@/components/WhatsAppFloat';
import { Seo } from '@/components/Seo';
import HomePage from '@/pages/Home';
import HizmetlerPage from '@/pages/Hizmetler';
import HakkimizdaPage from '@/pages/Hakkimizda';
import IletisimPage from '@/pages/Iletisim';
import AdminPage from '@/pages/Admin';

const SEO = {
  home: {
    title: 'İnegöl Evden Eve Nakliyat | Vira Nakliyat — Türkiye Geneli',
    description:
      "İnegöl merkezli Vira Nakliyat ile Türkiye'nin 81 iline sigortalı, asansörlü evden eve nakliyat. Ücretsiz keşif ve net fiyat için hemen arayın: 0533 916 61 08",
  },
  hizmetler: {
    title: 'Hizmetlerimiz | Vira Nakliyat — İnegöl Evden Eve Nakliyat',
    description:
      'Evden eve nakliyat, şehirlerarası taşımacılık, asansörlü taşıma, paketleme, eşya depolama ve ofis taşıma. İnegöl merkezli, Türkiye geneli hizmet.',
  },
  hakkimizda: {
    title: 'Hakkımızda | Vira Nakliyat — İnegöl Nakliyat Firması',
    description:
      "Vira Nakliyat: İnegöl'den Türkiye'nin dört bir yanına sigortalı ve sözleşmeli evden eve nakliyat. Hikâyemiz, ekibimiz ve çalışma ilkelerimiz.",
  },
  iletisim: {
    title: 'İletişim & Ücretsiz Teklif | Vira Nakliyat',
    description:
      'Ücretsiz keşif ve net fiyat teklifi için arayın: 0533 916 61 08. İnegöl / Bursa merkezli, Türkiye geneli evden eve nakliyat ve online teklif formu.',
  },
};

const withSeo = (element, seo) => (
  <>
    <Seo {...seo} />
    {element}
  </>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SmoothScroll = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return children;
};

function App() {
  return (
    <div className="App grain">
      <HelmetProvider>
        <BrowserRouter>
          <SmoothScroll>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={withSeo(<HomePage />, SEO.home)} />
              <Route path="/hizmetler" element={withSeo(<HizmetlerPage />, SEO.hizmetler)} />
              <Route path="/hakkimizda" element={withSeo(<HakkimizdaPage />, SEO.hakkimizda)} />
              <Route path="/iletisim" element={withSeo(<IletisimPage />, SEO.iletisim)} />
              <Route
                path="/admin"
                element={withSeo(<AdminPage />, {
                  title: 'Yönetim Paneli | Vira Nakliyat',
                  description: 'Vira Nakliyat yönetim paneli.',
                  noindex: true,
                })}
              />
            </Routes>
            <Footer />
            <WhatsAppFloat />
          </SmoothScroll>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
